type TranslateFn = (key: string, defaultValue?: string | number) => string;

export function getColorTranslation(colorStr: string, t?: TranslateFn): string {
    const translate = t ?? ((key: string, defaultValue?: string | number) => defaultValue?.toString() ?? key);

    return colorStr
        .split(",")
        .map((color) => color.trim())
        .filter(Boolean)
        .map((color) => translate(`product.colors.${color}`, color))
        .join(", ");
}